/**
 * Prevents the last visible legend item in a chart from being clicked.
 * This function ensures that at least one legend item remains visible at all times.
 * If a user attempts to click the last visible legend item to hide it, the click event is prevented.
 *
 * @returns A Highcharts.chart options object with event handlers for the legend configuration.
 */
export function restrictLastLegendItemClick() {
  return {
    events: {
      itemClick: function (e) {
        const visibleCount = this.allItems.filter(
          (item) => item.visible,
        ).length;
        if (e.legendItem.visible && visibleCount === 1) {
          e.preventDefault();
        }
      },
    },
  };
}
